import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { map, Observable } from 'rxjs';
import { DialogService } from '../services/dialog.service';

export interface CanCQMSComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
  hasUnsavedChanges?: () => boolean;
  isSaveInProgress?: () => boolean;
  getSaveChangesDialogConfig?: () => {
    title: string;
    message: string;
    cancelButtonText: string;
    confirmButtonText: string;
  };
}

@Injectable({
  providedIn: 'root'
})

export class CQMSChangesGuard implements CanDeactivate<CanCQMSComponentDeactivate> {

  constructor(private dialogService: DialogService) {}
  
  canDeactivate(component: CanCQMSComponentDeactivate): Observable<boolean> | Promise<boolean> | boolean {
    
    // Check if the component has unsaved changes
    if (component.hasUnsavedChanges && component.hasUnsavedChanges()) {
      // If user clicked save button to navigate away, bypass the dialog
      if (component.isSaveInProgress && component.isSaveInProgress()) {
        return true;
      }

      // Get dialog configuration from component or use defaults
      const dialogConfig = component.getSaveChangesDialogConfig ? 
        component.getSaveChangesDialogConfig() : 
        this.getDefaultDialogConfig();

      // Open the save changes dialog
      const dialogRef = this.dialogService.openSaveChangesDialog(
        dialogConfig.title,
        dialogConfig.message,
        dialogConfig.cancelButtonText,
        dialogConfig.confirmButtonText
      );

      // Return the dialog result as an Observable
      return dialogRef.afterClosed().pipe(
        map(result => !!result) // Convert result to boolean (true if confirmed, false if cancelled)
      );
    }

    // Check if the component has a custom canDeactivate method
    if (component.canDeactivate) {
      return component.canDeactivate();
    }
    return true; // Allow deactivation by default if no canDeactivate method is found

  }

  private getDefaultDialogConfig() {
    return {
      title: 'Unsaved Changes',
      message: 'You have unsaved changes. Are you sure you want to leave this page? All changes will be lost.',
      cancelButtonText: 'Cancel',
      confirmButtonText: 'Leave Page'
    };
  }
}